<template>
    <div class="o-proofCard u-w100 u-py20 u-overflowYAuto">
        <div class="o-proofCard__inner u-container">
            <ul v-if="!loading && proofCard.module_ratings && proofCard.module_ratings.length > 0" class="m-accordion u-listUnstyled">
                <li
                    v-for="(rating, index) in proofCard.module_ratings"
                    :key="index"
                    class="m-accordion__item u-mb15 u-bgWhite u-br u-border u-pt20 u-px20"
                >
                    <div 
                        class="m-accordion__titleHolder u-pb20" 
                        @click="toggleAccordion(index)"
                    >
                        <div class="m-accordion__title">
                            <h3 class="u-mb0">{{ rating.category }}</h3>
                        </div>
                        <div class="m-accordion__right">
                            <div
                                class="a-tag"
                                :class="{
                                    '-orange': rating.rating_value === 0,
                                    '-green': rating.rating_value === 1,
                                    '-purple': rating.rating_value === 2
                                }"
                            >
                                {{ rating.rating }}
                            </div>
                            <div class="a-iconButton -tiny -secondary">
                                <i :class="isOpen[index] ? 'bx bx-chevron-up' : 'bx bx-chevron-down'"></i>
                            </div>
                        </div>
                    </div>
                    <div 
                        v-show="isOpen[index]" 
                        class="m-accordion__items u-pb20"
                    >
                        <div class="u-br u-border u-px20 u-py20">
                            <div class="u-fw500">{{ $t('proofCard.feedback') }}</div>
                            {{ rating.feedback || $t('proofCard.noFeedback') }}
                        </div>
                    </div>
                </li>
            </ul>
            <div v-else-if="!loading">
                {{ $t('proofCard.noRating') }}
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, inject } from 'vue';
import { useI18n } from 'vue-i18n';
import api from '../services/api';

const proofCard = ref(null);
const loading = ref(true);
const currentId = inject('currentId');
const emit = defineEmits(['updateHeader']);
const { t } = useI18n();

const isOpen = ref([]);
const toggleAccordion = (index) => {
    isOpen.value[index] = !isOpen.value[index];
};

const fetchProofcard = async () => {
    try {
        const response = await api.get(`/proofcard/${currentId.value}`);

        if (response.status === 200) {
            proofCard.value = response.data;
            if (proofCard.value.module_title) {
                emit('updateHeader', proofCard.value.module_title);
            }
        }
    } catch (error) {
        console.error('Error fetching proofcard:', error);
    } finally {
        loading.value = false;
    }
};

onMounted(() => {
    fetchProofcard();
});
</script>
